import { required, useNotify, useRecordContext, useRefresh } from "react-admin";
import { useWatch } from "react-hook-form";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import { Grid } from "@mui/material";

import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { erasmusRequests } from "api/erasmusApi";
import { ErasmusApplicationStatuses } from "utils/constants";
import dataProvider from "server/dataProvider";

const validateEndAfterStart = (value, allValues) => {
  if (value && allValues?.absenceStartDate && value < allValues.absenceStartDate) {
    return "Крайната дата не може да е преди началната";
  }
  return undefined;
};

const AbsenceDatesFields = () => {
  const absenceStartDate = useWatch({ name: "absenceStartDate" });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <CustomDateInput
          source="absenceStartDate"
          label="Начало на отсъствие"
          validate={required()}
          required={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <CustomDateInput
          source="absenceEndDate"
          label="Край на отсъствие"
          minDate={absenceStartDate || undefined}
          validate={[required(), validateEndAfterStart]}
          required={true}
        />
      </Grid>
    </Grid>
  );
};

const AbsenceDatesDialog = ({ label = "Период на отсъствие" }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record || record.status === ErasmusApplicationStatuses.Closed) return null;

  const handleSent = async data => {
    await dataProvider.customRequest(
      erasmusRequests.updateAbsenceDates(record.id),
      {
        absenceStartDate: data.absenceStartDate,
        absenceEndDate: data.absenceEndDate,
      },
      "PUT",
    );

    notify("Успешно записан период на отсъствие.", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Период на отсъствие"
      onConfirm={handleSent}
      startIcon={<EventBusyIcon />}
      titleButton={label}
      btnStyle={{ width: "max-content" }}
      variant="contained"
      defaultValues={{
        absenceStartDate: record.absenceStartDate ?? null,
        absenceEndDate: record.absenceEndDate ?? null,
      }}
    >
      <AbsenceDatesFields />
    </FormModal>
  );
};

export default AbsenceDatesDialog;
